import { Modal } from 'antd';
import SIList from 'pages/SupplierInvoice/SlList';
import React from 'react';
import { SupplierInvoiceSelectedType } from './SupplierInvoiceSelect';


export type SupplierInvoiceSearchModalProps =  {
  visible: boolean;
  onCancel: () => void;
  setSupplierInvoice: (
    SupplierInvoice: SupplierInvoiceSelectedType
  ) => void;
  ctref?:string
};

const SupplierInvoiceSearchModal = ({
  onCancel,
  visible,
  setSupplierInvoice,
  ctref
}: SupplierInvoiceSearchModalProps) => {
  return (
    <Modal open={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <SIList
        onSelect={setSupplierInvoice}
        hideCol
        hideExtraAction
        ctref={ctref}
      />
    </Modal>
  );
};

export default SupplierInvoiceSearchModal;
